<template>
  <div>
    <ClosedDaysFilters
      :filters="filterState"
      :devices="devices"
      :columns="columns"
      @apply="handleApplyFilters"
      @export="handleExport"
    />

    <DataTable
      :rows="rows"
      :columns="columns"
      :sort="sort"
      @sort="sortBy"
      :isLoading="fetchingData"
    />

    <Pagination :pagination="meta" @change="changePage" class="mb-5" />
  </div>
</template>
  
<script>
import ClosedDaysService from "@/services/closedDaysService";
import ClosedDaysFilters from "@/components/Device/DaysGenericFilters.vue";
import DataTable from "@/components/Common/DataTable.vue";
import Pagination from "@/components/Common/Pagination.vue";

export default {
  name: "BoxClosedDays",
  components: {
    ClosedDaysFilters,
    DataTable,
    Pagination,
  },
  data() {
    const today = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(today.getDate() - 7);
    const formatDate = (date) => date.toISOString().split("T")[0];

    return {
      rows: [],
      devices: [],
      isMobile: false,
      fetchingData: true,
      columns: [],
      columnBlueprint: [
        { key: "id", label: "ID", hideOnMobile: true },
        {
          key: "device_id",
          label: "Device",
          hideOnMobile: true,
          filterable: true,
        },
        { key: "day_id", label: "Day ID", hideOnMobile: true },
        { key: "day_photo_count", label: "Photos" },
        { key: "day_coins_count", label: "Cash" },
        { key: "card_sum", label: "Card", filterable: false },
        { key: "money_sum", label: "Total", filterable: false },
        { key: "date", label: "Date" },
      ],
      filterState: {
        device_id: null,
        date_from: formatDate(oneWeekAgo),
        date_to: formatDate(today),
      },
      sort: {
        key: "id",
        order: "desc",
      },
      meta: {
        current_page: 1,
        last_page: 1,
        per_page: 100,
        total: 0,
      },
    };
  },
  methods: {
    setColumns() {
      this.columns = this.columnBlueprint.map((col) => ({
        ...col,
        visible: this.isMobile ? !col.hideOnMobile : true,
      }));
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
      this.setColumns();
    },
    sortBy(key) {
      if (this.sort.key === key) {
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      } else {
        this.sort.key = key;
        this.sort.order = "asc";
      }
      this.fetchData(this.meta.current_page);
    },
    async fetchData(page = 1) {
      this.fetchingData = true;
      const filters = {
        ...this.filterState,
        page,
        sort_key: this.sort.key,
        sort_order: this.sort.order,
      };

      try {
        const response = await ClosedDaysService.fetchAll(filters);
        this.rows = response.data.data;
        this.devices = response.data.devices;
        this.meta = response.data.meta;
        this.fetchingData = false;
      } catch (error) {
        console.error(
          error.customMessage || error.message || JSON.stringify(error)
        );
      } finally {
        this.fetchingData = false;
      }
    },
    async handleExport(filters) {
      try {
        const response = await ClosedDaysService.export(filters);

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        let filename = "box_closed_days_export.xlsx";
        const disposition = response.headers["content-disposition"];
        const match = disposition && disposition.match(/filename="?(.+?)"?$/);
        if (match) {
          filename = match[1];
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Export failed:", error);
      }
    },
    handleApplyFilters(newFilters) {
      this.filterState = { ...newFilters };
      this.fetchData();
    },
    handleClickOutside(event) {
      const dropdown = event.target.closest(".dropdown-menu");
      const button = event.target.closest(".btn");
      if (!dropdown && !button) {
        document.removeEventListener("click", this.handleClickOutside);
      }
    },
    changePage(page) {
      const pageNum = Number(page);
      if (
        !Number.isInteger(pageNum) ||
        pageNum < 1 ||
        pageNum > this.meta.last_page ||
        pageNum === this.meta.current_page
      ) {
        return;
      }
      this.fetchData(pageNum);
    },
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
    this.setColumns();
    this.fetchData();
    window.addEventListener("resize", this.handleResize);
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
  
  <style scoped>
th {
  user-select: none;
}
@media (max-width: 768px) {
  th,
  td {
    font-size: 0.85rem;
    padding: 0.4rem 0.5rem;
  }
}
</style>
  